// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"8af7130b","453":"99dcf01f","867":"45c890e1"}[chunkId] + ".chunk.js";
};